// @generated by protoc-gen-es v1.10.0
// @generated from file omnios/v1/diagram.proto (package omnios.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3 } from "@bufbuild/protobuf";

/**
 * @generated from message omnios.v1.GetSystemDiagramRequest
 */
export const GetSystemDiagramRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.GetSystemDiagramRequest",
  () => [
    { no: 1, name: "contexts", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 2, name: "include_workflows", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 3, name: "include_plugins", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 4, name: "include_event_flows", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 5, name: "include_services", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message omnios.v1.GetContextDiagramRequest
 */
export const GetContextDiagramRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.GetContextDiagramRequest",
  () => [
    { no: 1, name: "context", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.GetWorkflowDiagramRequest
 */
export const GetWorkflowDiagramRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.GetWorkflowDiagramRequest",
  () => [
    { no: 1, name: "workflow_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.GetEntityFsmDiagramRequest
 */
export const GetEntityFsmDiagramRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.GetEntityFsmDiagramRequest",
  () => [
    { no: 1, name: "entity_kind", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.GetPluginMapRequest
 */
export const GetPluginMapRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.GetPluginMapRequest",
  () => [
    { no: 1, name: "domain", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.GetEventFlowDiagramRequest
 */
export const GetEventFlowDiagramRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.GetEventFlowDiagramRequest",
  () => [
    { no: 1, name: "entity_kind", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.GetDataPipelineDiagramRequest
 */
export const GetDataPipelineDiagramRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.GetDataPipelineDiagramRequest",
  () => [
    { no: 1, name: "sink_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.GetDiagramMetricsRequest
 */
export const GetDiagramMetricsRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.GetDiagramMetricsRequest",
  () => [
    { no: 1, name: "node_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ],
);

/**
 * @generated from message omnios.v1.GetDiagramMetricsResponse
 */
export const GetDiagramMetricsResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.GetDiagramMetricsResponse",
  () => [
    { no: 1, name: "metrics", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "scalar", T: 9 /* ScalarType.STRING */} },
  ],
);

/**
 * All diagram RPCs return the same response: a JSON-serialized DiagramGraph.
 *
 * @generated from message omnios.v1.DiagramResponse
 */
export const DiagramResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.DiagramResponse",
  () => [
    { no: 1, name: "graph_json", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "node_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "edge_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

